"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const GenericMenu_1 = __importDefault(require("../genericMenuComponents/GenericMenu"));
const actions_1 = require("../../actions/actions");
const GeneralSettings_1 = require("./GeneralSettings");
const ControlsSettings_1 = require("./ControlsSettings");
const GraphicsSettings_1 = __importDefault(require("./GraphicsSettings"));
class IngameSettingsMenu extends react_1.Component {
    constructor(props) {
        super(props);
        this.state = {
            dialog: true,
            tab: 0,
        };
    }
    componentDidUpdate(prevProps, prevState) {
    }
    componentDidMount() {
    }
    setTab(tab) {
        this.setState({
            tab: tab,
        });
    }
    renderCurrentTab() {
        switch (this.state.tab) {
            case 0:
                return react_1.default.createElement(GeneralSettings_1.GeneralSettings, { currentGame: this.props.currentGame, singleGame: this.props.singleGame, token: this.props.token, guestAccount: this.props.guestAccount, handleClose: () => { (0, actions_1.toggleIngameSettingsMenu)(false); } });
            case 1:
                return react_1.default.createElement(GraphicsSettings_1.default, null);
            case 2:
                return react_1.default.createElement(ControlsSettings_1.ControlsSettings, null);
            default:
                return react_1.default.createElement("div", null,
                    "Tab ",
                    this.state.tab);
        }
    }
    render() {
        let { ingameSettingsActive, singleGame, token, guestAccount, currentGame } = this.props;
        const handleClickOpen = () => {
            (0, actions_1.toggleIngameSettingsMenu)(true);
        };
        const handleClose = () => {
            (0, actions_1.toggleIngameSettingsMenu)(false);
        };
        const { tab } = this.state;
        return (react_1.default.createElement(GenericMenu_1.default, { menuTitle: 'Settings', menuActive: ingameSettingsActive, onOpen: handleClickOpen, onClose: handleClose, menuColumns: [{ name: 'General' }, { name: 'Graphics' }, { name: 'Controls' }], onChangeTab: (tab) => { this.setTab(tab); }, allowOverflow: true, currentTab: tab }, this.renderCurrentTab()));
    }
}
function mapStateToProps(state) {
    return {
        ingameSettingsActive: state.stuff.ingameSettingsActive,
        token: state.stuff.token,
        guestAccount: state.stuff.guestAccount,
        currentGame: state.stuff.currentGame,
        singleGame: state.stuff.singleGame,
    };
}
exports.default = (0, react_redux_1.connect)(mapStateToProps)(IngameSettingsMenu);
